export const drivers = [
  {
    name: "Ahmadi",
    number: "+255000000",
    whatsup: "+255000000",
    driverid: "001",
    // email: "zanzifooddelivery@gmail.com",
    email: "zanzifooddelivery@gmail.com",
  },
];
